import React, { useState } from 'react';
import './NavBar.css';
import { Link } from 'react-router-dom';
import { Navbar, NavbarToggler, Collapse, Nav, UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem, NavItem } from 'reactstrap';

const DropdownMenuItem = ({ items, label, dropdownId, handleLinkClick, handleDropdownEnter, handleDropdownLeave, hoveredDropdown }) => (
  <UncontrolledDropdown
    nav
    inNavbar
    onMouseEnter={() => handleDropdownEnter(dropdownId)}
    onMouseLeave={handleDropdownLeave}
    isOpen={hoveredDropdown === dropdownId}
    className="position-relative"
  >
    <DropdownToggle nav aria-haspopup={true} aria-expanded={hoveredDropdown === dropdownId}>
      {label}
    </DropdownToggle>
    <DropdownMenu end>
      {items.map((item, index) => (
        item.subItems ? (
          <UncontrolledDropdown key={index} nav inNavbar className="submenu-dropdown">
            <DropdownItem className="dropdown-toggle submenu-item">
              {item.label}
            </DropdownItem>
            <DropdownMenu className="submenu">
              {item.subItems.map((subItem, subIndex) => (
                <DropdownItem key={subIndex} >
                  {subItem.path.startsWith("http") ? (
                    <a href={subItem.path} target="_blank" rel="noopener noreferrer" className="dropdown-link">
                      {subItem.label}
                    </a>
                  ) : (
                    <Link to={subItem.path} className="dropdown-link" onClick={handleLinkClick}>
                      {subItem.label}
                    </Link>
                  )}
                </DropdownItem>
              ))}
            </DropdownMenu>
          </UncontrolledDropdown>
        ) : (
          <DropdownItem key={index}>
            {item.path.startsWith("http") ? (
              <a href={item.path} target="_blank" rel="noopener noreferrer" className="dropdown-link">
                {item.label}
              </a>
            ) : (
              <Link to={item.path} className="dropdown-link" onClick={handleLinkClick}>
                {item.label}
              </Link>
            )}
          </DropdownItem>
        )
      ))}
    </DropdownMenu>
  </UncontrolledDropdown>
);

const ExampleNavbar = (props) => {
  const [isOpen, setIsOpen] = useState(false);
  const [hoveredDropdown, setHoveredDropdown] = useState(null);

  const toggle = () => setIsOpen(!isOpen);
  const handleDropdownEnter = (dropdown) => setHoveredDropdown(dropdown);
  const handleDropdownLeave = () => setHoveredDropdown(null);

  const handleLinkClick = () => {
    if (window.innerWidth < 768) {
      setIsOpen(false);
    }
    setHoveredDropdown(null);
    
  };

  const dropdownData = {
    "About Us": [

      { path: "/introduction", label: "Introduction" },
      { path: "/definition", label: "Definition" },
      { path: "/organisation", label: "Organisation Chart" },
      { path: "/whoWho", label: "Who’s Who" },
      { path: "/brochure", label: "Brochure" },
      { path: "/actsRules", label: "Acts/Rules" },
      { path: "/notification-order", label: "Notifications & Orders" },
      { path: "/amalgamated", label: "Amalgamated Fund" },
      { path: "/dsr", label: "DSR Fund" },
      { path: "/donationpage", label: "Armed Forces Flag Day Fund" },
      
    ],
  
    CAPF: [
      { path: "/capf", label: "About CAPF" },
      { path: "/capf-policy", label: "Policies" },
      { path: "/capf-registration-info", label: "Register" },
      { path: "/capf-martyrs", label: "Martyrs" },
      { path: "/capf-awardees", label: "Awardees" }, 
      { path: "/ranks", label: "Ranks Structure" }, 
      { path: "/capf-id-card", label: "Issuing of ID Card" }, 
    ],
    ESM: [
      { path: "/esm", label: "About ESM" },
      // { path: "/esm-registration-info", label: "Register" },
      { path: "/esm-martyrs", label: "Martyrs" },
      { path: "/esm-awardees", label: "Awardees" },
      { path: "/welfare-schemes", label: "Welfare Schemes" }, 
    ],
    
    "Facilities for ESM": [
      { path: "/SainikSadan", label: "Integrated Sainik Sadan" },
      { path: "/SainikRestHouses", label: "Sainik Rest Houses" },
      { path: "/canteen-stores", label: "Canteens" },
      { path: "/echs", label: "ECHS Polyclinics" },
      { path: "/nalsa", label: "NALSA" },
    ],
    "RTI": [
      { path: "/right-information", label: "List of SPIO" },
    ],
    "Agniveer": [
      { path: "/policy", label: "Policies" },
      { path: "/reservation", label: "Reservation" },
      { path: "/notices", label: "Notices" },
    ],
  };

  return (
    <div className="navbar-container">
      <Navbar  expand="md" >
        <NavbarToggler onClick={toggle} style={{border:"none"}}/>
        <Collapse isOpen={isOpen} navbar>
          <Nav className="navbar-nav w-100 justify-content-start gap-2" navbar>
            <NavItem>
              <Link to="/" className="nav-link" onClick={handleLinkClick}>
                Home
              </Link>
            </NavItem>
            {Object.entries(dropdownData).map(([key, items]) => (
              <DropdownMenuItem
                key={key}
                items={items}
                label={key.charAt(0).toUpperCase() + key.slice(1)}
                dropdownId={key}
                handleLinkClick={handleLinkClick}
                handleDropdownEnter={handleDropdownEnter}
                handleDropdownLeave={handleDropdownLeave}
                hoveredDropdown={hoveredDropdown}
              />
            ))}
          

<NavItem>
              <Link to="/sainikSchool" className="nav-link" onClick={handleLinkClick}>
              Sainik Schools
              </Link>
            </NavItem>
<NavItem>
              <Link to="/war-memorials" className="nav-link" onClick={handleLinkClick}>
              War Memorials
              </Link>
            </NavItem>
{/* <NavItem>
              <Link to="/skill-info" className="nav-link" onClick={handleLinkClick}>
             Skill Courses
              </Link>
            </NavItem> */}
<NavItem>
              <Link to="/media" className="nav-link" onClick={handleLinkClick}>
             Media
              </Link>
            </NavItem>
<NavItem>
              <Link to="/contactUs" className="nav-link" onClick={handleLinkClick}>
             Contact Us
              </Link>
            </NavItem>


            <div className="d-flex ms-md-auto align-items-center justify-content-center flex-md-nowrap" >
              
            <NavItem className="moblogin ms-1" id='moblogin' >
              <Link to="/login" className="nav-link  text-white" style={{ backgroundColor: "#ea832e", padding: "8px 12px", borderRadius: "2px" }} onClick={handleLinkClick}>
                 <span style={{ animation: 'blink 3s infinite' }}>Login</span>
              </Link>
            </NavItem>
            </div>
          </Nav>
        </Collapse>
      </Navbar>
    </div>
  );
};

export default ExampleNavbar;
